import React, { FC, useEffect, useState, useRef } from "react";
import { cloneDeep, filter, find, forEach, get, includes, isEmpty, List, map, set, size, isEqual, noop, some, isNil, has, capitalize, trim , toString} from "lodash";
import { Button, Collapse, DatePicker, Radio, Input } from "antd";
import moment, { Moment } from "moment";
import { forkJoin } from "rxjs";
// adding local dependencies
import History from "./history/history";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import CareCoordinationService from "../../../../../services/care-coordination";
import {
  ActionFreeText,
  ActionMultiDropDown,
  ActionButton,
  ActionNoValue,
  ActionRadio,
  ACTIVE,
  COMPLETE,
  NOT_APPLICABLE,
  Info,
  INPROGRESS,
  SingleDate,
  SingleDropDown,
  ActionRemainder,
  ActionRadioPrgm,
  ActionDateTime,
  ActionMultiLevel,
  ActionTextArea,
} from "../../constants";
import InputField from "../input/input";
import "./subTask.scss";
import SimpleSelect from "@components/simpleSelect/simpleSelect";
import {
  CASE_STATUS_REASON_CALCULATE_BUTTON,
  CASE_STATUS_REASON_UPDATE,
  USER_ACTION_CARD_PROGRAM,
  USER_ACTION_DESCRIPTION_SCORE_CALCULATE,
  USER_ACTION_DESCRIPTION_TASK_UPDATE,
  USER_ACTION_LOCATION_TASK_BUTTON,
  USER_ACTION_LOCATION_TASK_UPDATE_BUTTON,
  USER_ACTION_MODULE_MEMBER_DETAIL,
  USER_ACTION_TAB_CARE_MANAGEMENT,
  dateFormatConfig,
  careManagementDependentFieldsForScore,
  CREATE,
  CARE_PRGM,
  CREATE_CARE_PRGM,
} from "@utils/constants";
import { getClientName, caseLessComparision, stringToNum, isNotEmptyOrWhiteSpace } from "@utils/helpers";
import MultiSelect from "@components/multiSelect/multiSelect";
import MultiLevelSelect from "@components/multiLevelSelect/multiLevelSelect";
import { CARE_MANAGEMENT_SCREEN_TITLE, MEMBER_DETAILS_CARE_MANAGEMENT_TASKS } from "@utils/constants";
import "./task.scss";
import { CareManagementCanEdit } from "@components/accessLevel/careManagementCanEdit";
import Remainder from "../remainder/remainder";
import Program from "../program/program";
import membersService from "@services/members.service";
import memberDetailsService from "@services/memberDetails.service";
import { useDurableStore } from "@stores/useDurableStore";
import { mapRules } from "../../helpers";
import { PopUpType, PROGRAM_EXISTS, SCORE_RANGES } from "./popups";
import sessionService from "@services/session.service";
import { useHelperApiFunctions, useTaskValidations } from "@utils/customHooks";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../../../constants/constants";
import { useProgram, useProgramMetaData } from "../../customHooks";

const { Panel } = Collapse;

const { TextArea } = Input;

/******************************************************************************* */

// Code practice - while updating active program state of store, please update previous program state accordingly this is to handle and maintain history across intervention

/******************************************************************************* */

const SubTask = (props: {
  programId: any;
  interventionId: any;
  patientId: any;
  taskId: any;
  completeParentTask: any;
  updateParentTask: any;
  updateParentTaskNew: any;
  patientProgramId: any;
  taskDescription: any;
  spinner: any;
  setSpinner: any;
  canEdit: boolean;
  taskReminderRef: any;
  forceUpdateReminder: boolean;
}) => {
  // timeStamp format task history
  // const taskHistoryTimeFormat = "DD MM YY | HH:mm:ss";
  // const taskHistoryTimeFormat = "D MMM YY";

  // getting state from the Store
  const programsData = cloneDeep(useCareCoordinationStore((state: { dataForCareCoordination: any }) => state.dataForCareCoordination));
  const setProgramsData = useCareCoordinationStore((state) => state.setDataForCareCoordination);
  const assignedPrograms = useCareCoordinationStore((state) => state.assignedPrograms);
  const previousProgramsData = useCareCoordinationStore((state) => state.previousDataForCareCoordination);
  const setPreviousDataForCareCoordination = useCareCoordinationStore((state) => state.setPreviousDataForCareCoordination);
  const {additionalDataIds} = useProgramMetaData({programId : props.programId});
  const rules = cloneDeep(useCareCoordinationStore((state) => state.rules));
  const [isTaskValid, haveMandatorySubTasks] = useCareCoordinationStore((state: any) => [state.isTaskValid, state.haveMandatorySubTasks]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  // finding out active program and active intervention
  const activeIntervention = find(programsData?.interventions, { id: props?.interventionId });
  const activeTask = find(activeIntervention?.tasks, { id: props?.taskId });
  const patientId = props.patientId;
  // finding out active program and intervention of previous state
  const activeCopyIntervention = find(previousProgramsData?.interventions, { id: props?.interventionId });
  const activeCopyTask = find(activeCopyIntervention?.tasks, { id: props?.taskId });

  // creating local states
  const [isUpdating, setIsUpdating] = useState(false);
  const [taskIdGoingToUpdate, setTaskIdGoingToUpdate] = useState(null);
  const [serviceCallFlag, setServiceCallFlag] = useState(false);
  const [dependantSubTasks, setDependantSubTasks] = useState<{ id: number; display: boolean; parent: number; rule: string }[]>([]);
  const [isUserOnHistory, setIsUserOnHistory] = useState(false);
  const [subTaskLastUpdatedDate, setSubTaskLastUpdatedDate] = useState<any>();
  const [programEndDate, setProgramEndDate] = useState<Moment | undefined>();
  const [selectedValuesOfProgram, setSelectedValuesOfProgram] = useState<number | undefined>();
  const [loading, setLoading] = useState(false);
  const setInterventionStartDate = useCareCoordinationStore((state) => state.setInterventionStartDate);
  const [modalData, setModalData] = useState<any>({ open: false, programName: "", description: "" });
  const [prvBtn, setPrvBtn] = useState(false);
  const [nxtBtn, setNxtBtn] = useState(true);
  const scoreData = useDurableStore((state) => state.scoreData);
  const setScoreData = useDurableStore((state) => state.setScoreData);
  const currentMember = membersService?.getCurrentMember;
  const getUserActionParams = (userActionDescription: any, userActionLocation: any, reason: any) => {
    let props = {
      caseStatusReasonTxt: reason,
      actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
      actionTab: USER_ACTION_TAB_CARE_MANAGEMENT,
      actionCard: `${get(programsData, "displayName")}$|${get(programsData, "patientProgramId")}$|${USER_ACTION_CARD_PROGRAM}`,
      actionLocation: userActionLocation,
      actionDescription: userActionDescription,
    };
    return props;
  };

  const actionData = useRef<any>({});

  const { getTaskvalidations, isTaskValidationSuccess } = useTaskValidations({ activeTask, dependantSubTasks });

  const {programDescription} = useProgram({ programID : props?.programId});

  const {addGlobalEntry} = useHelperApiFunctions();

  const subtasksInitialLoad = () => {
    console.log("SubTask.useEffect");

    // creating empty dependent Items Array, late on going to update the state with this array

    /* 
      1. HRP V 2.0 Changes 

      * isDisplayHistory flag -> on every new instance if isDisplayHistory is N, we clear the pre-existing values
      * Collecting all the dependent subTask and adding the properties specified by the rules based on the operation and its value
        1. Properties -> display -> true

        Operation can be chained in future based on template rules
      //////////////////////////////////////////
    */
    let dependantItems: any = [];

    forEach(activeTask?.subtasks, (task) => {
      let dependents: any[] = [];

      const rule: any = [];
      forEach(task?.ruleName, (item: any) => {
        const temp_rule = find(rules, { ruleName: item?.name });
        rule.push(temp_rule);
      });

      forEach(task?.ruleName, (item: any) => {
        forEach(item?.children, (deps_tasks: any) => {
          if (get(find(rules, { ruleName: get(item, "name") }), "properties[0].property") === "display") {
            dependents.push({
              id: parseInt(deps_tasks),
              display: false,
              parent: task.id,
              rule: item.name,
            });
          }
        });
      });

      mapRules(rule, task, dependents, activeTask);

      dependantItems = [...dependantItems, ...dependents];
    });
    setDependantSubTasks(dependantItems);
    setProgramsData(programsData);
    // Setting last updated date time stamp for a task
    setSubTaskLastUpdatedDate(latestSubTaskUpdatedDate());
  };

  const getScoreData = () => {
    const scoreSubtasksKeys = map(
      filter(activeTask?.subtasks, (s: any) => s.type === ActionButton && !has(scoreData, s.name)),
      "name"
    );

    const promises: any[] = [];
    scoreSubtasksKeys.forEach((key: any) => {
      promises.push(CareCoordinationService.fetchScoreData(key));
    });

    props.setSpinner(true);
    forkJoin(...promises).subscribe({
      next: (v: any) => {
        const scores: any = {};
        forEach(v, (res: any, i: number) => {
          scores[scoreSubtasksKeys[i]] = res.data.data;
        });
        setScoreData({ ...scores });
        // props.setSpinner(false);
      },
      error: (e) => {
        // props.setSpinner(false);
        console.log("update status failed");
      },
      complete: () => {
        props.setSpinner(false);
      },
    });
  };

  useEffect(() => {
    //below subtasksInitialLoad function will set the subtasks based on rules on inital Load
    subtasksInitialLoad();

    //get score data function will fetch the score data based on type of subtask
    getScoreData();
  }, []);

  // Function to fetch last updated of a task
  const latestSubTaskUpdatedDate = () => {
    const tempSubtask = get(activeTask, "subtasks", []);
    let latestUpdatedDate: any = undefined;
    forEach(tempSubtask, (item: any) => {
      if (item.subtaskUpdateDate) {
        if (!latestUpdatedDate) {
          latestUpdatedDate = moment.utc(item.subtaskUpdateDate).local();
        } else {
          latestUpdatedDate = moment.utc(item.subtaskUpdateDate).local() > latestUpdatedDate ? moment.utc(item.subtaskUpdateDate).local() : latestUpdatedDate;
        }
      }
    });
    return latestUpdatedDate;
  };

  // Updating store for updating all the edited task and updating task history transaction service
  const updateTransactionHistoryTable = (arr: any) => {
    console.log("SubTask.updateTransactionHistoryTable");

    forEach(arr, (item: any) => {
      if (item?.status !== "success") {
        const tempActiveSubTask = find(activeTask?.subtasks, { id: item?.data?.activeSubTask?.id });
        set(tempActiveSubTask, "value", find(activeCopyTask?.subtasks, { id: item?.data?.activeSubTask?.id })?.value);
      } else {
        const tempActiveSubTask = find(activeTask?.subtasks, { id: item?.data?.activeSubTask?.id });
        set(tempActiveSubTask, "subtaskUpdateDate", `${moment.utc()}`);
      }
    });

    set(activeCopyTask, "subtasks", activeTask.subtasks);
    setSubTaskLastUpdatedDate(latestSubTaskUpdatedDate());
    setProgramsData(programsData);
    setPreviousDataForCareCoordination(previousProgramsData);
    setServiceCallFlag(!serviceCallFlag);
    setIsUpdating(false);
    if (activeTask?.historyFlag === "Y") {
      setIsUserOnHistory(true);
    }
    props.setSpinner(false);
  };

  // Updating subtask onchange for current state and logic to update dependents subtask and setting its value to null
  const updateTaskAndSetDependents = ({ activeSubTask, value, dropDownOptions , newReminder}: any, clearFlag?: boolean) => {
    console.log("SubTask.updateTaskAndSetDependents");
    if(newReminder) {
      set(activeSubTask, "reminders", [...get(activeSubTask, "reminders" ,[]) , ...newReminder]);
    } else {
      set(activeSubTask, "value", `${value}`);
    }
    // show or hide Dependent SubTasks
    const _dependantSubTasks = cloneDeep(dependantSubTasks);

    const rule: any = [];
    forEach(activeSubTask?.ruleName, (item: any) => {
      const temp_rule = find(rules, { ruleName: item?.name });
      rule.push(temp_rule);
    });

    mapRules(rule, activeSubTask, _dependantSubTasks, activeTask);

    setProgramsData(programsData);
    setDependantSubTasks(_dependantSubTasks);
    setIsUpdating(false);
  };

  // Creating history for the current task state
  const createTaskHistory = async () => {
    await CareCoordinationService.createTaskHistory({
      taskId: props.taskId,
    }).subscribe({
      next: (v) => {
        let status = programsData?.interventions
          ?.map((item: any) => {
            return item?.tasks?.filter((task: any) => {
              return task?.id === props.taskId;
            });
          })
          ?.flat(Infinity)?.[0]?.isAutoAssign;
        if (status === "Y" && (programsData?.assgnd_user_id === null || programsData?.assgnd_user_id === "null")) {
          CareCoordinationService.updateAssignedStatus({
            programId: props?.programId,
            patientProgramId: props?.patientProgramId,
            patientId: props.patientId,
            userId: sessionService?.getUser()?.id,
          }).subscribe({
            next: (v) => {
              set(programsData, "assgnd_user_id", v.data.data.assignedTo);
              set(programsData, "userName", v.data.data.userName);
              setProgramsData(programsData);
              console.log("updated status successfully");
              const taskId = programsData?.interventions
                ?.map((item: any) => {
                  return item?.tasks?.map((task: any) => {
                    return Number(task?.id);
                  });
                })
                .flat(Infinity);
              const subtaskId = programsData?.interventions
                ?.map((item: any) => {
                  return item?.tasks?.map((task: any) => {
                    return task?.subtasks?.map((subtask: any) => {
                      return subtask?.id;
                    });
                  });
                })
                .flat(Infinity);
              CareCoordinationService.updateReminderStatus({ patientId: props?.patientId, assignedUserId: sessionService?.getUser()?.id, tasksId: taskId, subtasksId: subtaskId }).subscribe({
                next: (v) => {},
                error: (e) => {},
              });
            },
            error: (e) => {
              console.log("update status failed");
            },
          });
        }
        editService();
      },
      error: (e) => {
        console.log(e);
        props.setSpinner(false);
        setIsUpdating(false);
      },
    });
  };

  // tracking of all the edited task
  const updateSubTaskGroup = async ({taskId , value , dropDownOptions , newReminder}: any) => {
    const activeSubTask = find(activeTask?.subtasks, { id: taskId });
    updateTaskAndSetDependents({ activeSubTask: activeSubTask, value: value, dropDownOptions: dropDownOptions , newReminder : newReminder});
  };

  // Filtering task which are not changed/edited ( calling edit api only for subtask which are changed )
  const getFilterChangedSubtask = () => {
    if (activeTask.historyFlag === "Y") {
      return activeTask?.subtasks?.filter((item: any) => {
        let previousSubTaskValue = find(activeCopyTask?.subtasks, { id: item.id })?.value;
        previousSubTaskValue = `${trim(previousSubTaskValue ?? "")}`.length ? previousSubTaskValue : null;

        let currentSubTaskValue = item?.value;
        currentSubTaskValue = `${trim(currentSubTaskValue ?? "")}`.length ? currentSubTaskValue : null;

        //the below if condition is for there is a scenario where previousSubTaskValue is null and currentSubTaskValue is empty string (' ')
        if (isNotEmptyOrWhiteSpace(previousSubTaskValue) || isNotEmptyOrWhiteSpace(currentSubTaskValue)) {
          return `${trim(currentSubTaskValue ?? "")}`.length > 0 || previousSubTaskValue !== currentSubTaskValue;
        }

        return false;
      });
    } else {
      return activeTask?.subtasks?.filter((item: any) => {
        let previousSubTaskValue = find(activeCopyTask?.subtasks, { id: item.id })?.value;
        //the below if condition is for there is a scenario where previousSubTaskValue is null and currentSubTaskValue is empty string (' ')
        if (isNotEmptyOrWhiteSpace(item.value) || isNotEmptyOrWhiteSpace(previousSubTaskValue)) {
          return !isEqual(item.value, previousSubTaskValue);
        } else {
          return false;
        }
      });
    }
  };

  const onProgramCreationCancel = (id: number) => {
    //if the user clicks on cancel while creating the program or the program already exists and not complete this function will get executed
    const tempSubtask = find(activeTask?.subtasks, { id: id });
    set(tempSubtask, "value", null);
    props.setSpinner(false);
    setSelectedValuesOfProgram(undefined);
    setProgramsData(programsData);
  };

  const calculateScoresBeforeUpdate: any = (scoreSubtasks : any[] , updateSubtaskCallback : any) => {
      const scoreSubtasksPayload: any[] = [];

      scoreSubtasks.forEach((s: any) => {
        scoreSubtasksPayload.push(getScorePayload(s));
      });
      let promises: any[] = [];
      scoreSubtasks.forEach((subtask: any, index: number) => {
        let paramsPayload = scoreSubtasksPayload[index];
        if (Object.keys(paramsPayload)?.length > 0) {
          promises.push(
            CareCoordinationService.calculateScore({
              patientId: patientId,
              programId: props.programId,
              patientProgramId: props.patientProgramId,
              interventionId: activeIntervention?.id,
              taskId: props.taskId,
              subTaskId: subtask.id,
              name: subtask.name,
              ...paramsPayload,
            })
          );
        } else {
          setModalData({ open: true, type: PROGRAM_EXISTS, programName: "", description: `The assessment flag isn't setup correctly in template` });
        }
      });

      forkJoin(...promises).subscribe({
        next: (responses) => {
          responses.forEach((response: any) => {
            const res = response?.data?.data;
            forEach(res, (item) => {
              const _activeSubTask = find(activeTask?.subtasks, { id: item.subtaskId });
              set(_activeSubTask, 'value' ,item?.value ? toString(item?.value) : item?.value);
            });
          });
          setProgramsData(programsData);
          updateSubtaskCallback();
        },
        error: (e) => {
          console.log(e);
        },
      });
  };

  function updateSubtaskCallback() {
    const changedSubtasks = getFilterChangedSubtask();
    const createProgramTask = find(changedSubtasks, { type: ActionRadioPrgm });
    const rule = find(rules, { ruleName: get(createProgramTask, "ruleName[0].name") });
    if (createProgramTask && caseLessComparision(createProgramTask.value, rule?.value)) {
      const programToBeCreated = find(
        assignedPrograms.filter((program: any) => program.status !== "Active"),
        (program) => caseLessComparision(program.name, createProgramTask.name)
      );

      if (programToBeCreated) {
        if (get(rule, "properties[0].property") === CARE_PRGM && get(rule, "properties[0].value") === CREATE) {
          actionData.current = {
            action: CREATE_CARE_PRGM,
            cancelCallBack: () => {
              onProgramCreationCancel(createProgramTask.id);
            },
            updateCallBack: () => {
              // Update tasks only with historyFlag === "Y"
              if (activeTask.historyFlag === "Y") {
                createTaskHistory();
              } else {
                editService();
              }
            },
          };
          setInterventionStartDate(undefined);
          setSelectedValuesOfProgram(programToBeCreated.id);
          setIsModalVisible(true);
        }
      } else {
        onProgramCreationCancel(createProgramTask.id);
        setModalData({ open: true, type: PROGRAM_EXISTS, programName: find(assignedPrograms, (program) => caseLessComparision(program.name, createProgramTask.name)).description, description: "" });
      }
    } else {
      // Update tasks only with historyFlag === "Y"
      if (activeTask.historyFlag === "Y") {
        createTaskHistory();
      } else {
        editService();
      }
    }
    const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
      USER_ACTION_DESCRIPTION_TASK_UPDATE,
      `${get(activeTask, "description")}$|${USER_ACTION_LOCATION_TASK_UPDATE_BUTTON}`,
      CASE_STATUS_REASON_UPDATE
    );
    membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
      next: (v) => {
        console.log("updated status successfully");
      },
      error: (e) => {
        console.log("update status failed");
      },
    });
  }

  // Calling update subTask Service
  const updateSubTaskService = () => {
    console.log("SubTask.updateSubTaskService");
    props.setSpinner(true);
    const scoreSubtasks = filter(activeTask?.subtasks, (s: any) => s.type === ActionButton);
    if (scoreSubtasks.length > 0) {
      calculateScoresBeforeUpdate(scoreSubtasks , updateSubtaskCallback);
    } else {
      updateSubtaskCallback();
    } 
  };

  const editService = async () => {
    //update task if it is in active state to in progress
    if (activeTask.status === ACTIVE) {
      activeTask.status = INPROGRESS;
      activeCopyTask.status = INPROGRESS;
      await CareCoordinationService.updateTask({
        patientId: patientId,
        programId: props.programId,
        interventionId: props?.interventionId,
        status: activeTask.status,
        taskId: props?.taskId,
        value: activeTask.value,
        taskCreateDate: activeTask.taskCreateDate,
        taskEndDate: activeTask.taskEndDate,
      }).subscribe({
        next: async (v: any) => {},
        error: (e) => {
          activeTask.status = ACTIVE;
          activeCopyTask.status = ACTIVE;
        },
      });
    }

    if (get(activeTask, "description", "").toLowerCase().includes("outreach")) {

      const changedSubtasks = getFilterChangedSubtask();

      const outreachTimeStamp = get(changedSubtasks, "[0].value");

      const modeOfOutreach = get(changedSubtasks, "[1].value");

      const outcomeOfOutreach = get(changedSubtasks, "[2].value");

      const globalEntryData = {
        struct_type: "outreach_add",
        entryData: {
          "2": {
            value: outreachTimeStamp,
            type: "DATETIME",
          },
          "3": {
            value: modeOfOutreach,
            type: "IMAGE_RADIO",
          },
          "4": {
            value: outcomeOfOutreach,
            type: "DROPDOWN",
          },
        },
        patient_id: patientId,
        level: `Program Level$|${programDescription}`,
      };

      addGlobalEntry(globalEntryData);
    }

    let a: any = [];
    await Promise.all(getFilterChangedSubtask().map(async (item: any) => await updateTask(item))).then((values: any) => {
      forEach(values, async (item: any) => {
        await item.call.subscribe({
          next: async (v: any) => {
            a.push({
              status: "success",
              data: item.data,
            });
            if (get(item.data.activeSubTask, "attrId", null) !== null && get(item.data.activeSubTask, "attrId", null) !== 0) {
              // updating the Intervention Detail Over here
              CareCoordinationService.updateIntervention({
                patientId: patientId,
                programId: props.programId,
                patientPgmId: props.patientProgramId,
                interventionId: activeIntervention?.id,
                detailId: item?.data?.activeSubTask?.attrId,
                detailValue: additionalDataIds.includes(get(item, 'data.activeSubTask.subtaskTempId', null)) ? moment(moment(get(item, 'data.value', null)).utc().format("YYYY-MM-DDTHH:mm:ss.SSS") ).utc() : item?.data?.value,
                programName: assignedPrograms.find((p: any) => p.id === props.programId).name,
                subtaskTempId : item?.data?.activeSubTask?.subtaskTempId
              }).subscribe({
                next: async (v) => {
                  const detail = find(activeIntervention?.interventionDetails, { labelId: item?.data?.activeSubTask.attrId });
                  detail.value = additionalDataIds.includes(get(item, 'data.activeSubTask.subtaskTempId', null)) ? moment(moment(get(item, 'data.value', null)).utc().format("YYYY-MM-DDTHH:mm:ss.SSS") ).utc() : item?.data?.value;
                  updateTaskAndSetDependents({ activeSubTask: item.data.activeSubTask, value: item?.data?.value, dropDownOptions: item?.data?.dropDownOptions });
                  if (item?.data?.activeSubTask?.description) {
                    const programsDataCopy = cloneDeep(programsData);
                    const interventionDetails = get(programsDataCopy, "interventions[0].interventionDetails", []);
                    const intervention = find(interventionDetails , {labelId : item?.data?.activeSubTask.attrId});
                    intervention.value = additionalDataIds.includes(get(item, 'data.activeSubTask.subtaskTempId', null)) ? moment(moment(get(item, 'data.value', null)).utc().format("YYYY-MM-DDTHH:mm:ss.SSS") ).utc() : item?.data?.value;
                    setProgramsData(programsDataCopy);
                  }
                },
                error: (e) => {},
              });
            }
            props.setSpinner(false);
            if (a.length === getFilterChangedSubtask().length) {
              updateTransactionHistoryTable(a);
            }
          },
          error: (e: any) => {
            a.push({
              status: "error",
              data: item.data,
            });
            if (a.length === getFilterChangedSubtask().length) {
              updateTransactionHistoryTable(a);
            }
            props.setSpinner(false);
          },
        });
      });
    });
  };

  // updating the task
  const updateTask = async (subTask: any) => {
    const activeSubTask = find(activeTask?.subtasks, { id: subTask?.id });
    if (!(activeSubTask?.value === null && activeSubTask?.value === "")) {
      setIsUpdating(true);
      setTaskIdGoingToUpdate(subTask?.id);
      return {
        call: CareCoordinationService.updateSubTask({ patientId: patientId, interventionId: activeIntervention?.id, taskId: props.taskId, subTaskId: subTask?.id, value: activeSubTask?.value }),
        data: { activeSubTask: activeSubTask, value: activeSubTask?.value },
      };
    }
  };

  // Function check for task whether subtasks are edited or not
  const disableUpdate = () => {
    return isEqual(activeTask, activeCopyTask);
  };

  // Reset/Cancel subtask if fields are changed // taking back to previous state
  const resetSubTaskFields = () => {
    activeTask.subtasks = activeCopyTask.subtasks;
    setProgramsData(programsData);

    let dependantItems: any = [];

    forEach(activeCopyTask.subtasks, (task) => {
      let dependents: any[] = [];

      const rule: any = [];
      forEach(task?.ruleName, (item: any) => {
        const temp_rule = find(rules, { ruleName: item?.name });
        rule.push(temp_rule);
      });

      forEach(task?.ruleName, (item: any) => {
        forEach(item?.children, (deps_tasks: any) => {
          if (get(find(rules, { ruleName: get(item, "name") }), "properties[0].property") === "display") {
            dependents.push({
              id: parseInt(deps_tasks),
              display: false,
              parent: task.id,
              rule: item.name,
            });
          }
        });
      });

      mapRules(rule, task, dependents, activeTask);

      dependantItems = [...dependantItems, ...dependents];
    });
    setDependantSubTasks(dependantItems);

    // If task has history on cancel it will take back to last updated state and will be in history mode
    if (activeTask?.historyFlag === "Y") {
      setIsUserOnHistory(true);
    }
    if (some(activeTask.subtasks, (obj) => obj.value)) {
      setPrvBtn(false);
    } else {
      setPrvBtn(true);
    }
  };

  // function responsible to show the task's barrier modal
  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  // function responsible to hide the task's barrier modal
  // const handleCancel = () => {
  //   const emptyMandatoryTasks = filter(
  //     filter(props.subTasks, (item) => {
  //       const dependantIds = map(dependantSubTasks, (obj) => {
  //         return obj.id;
  //       });
  //       return !includes(dependantIds, item.id) || !isEmpty(find(dependantSubTasks, { display: true, id: item.id }));
  //     }),
  //     (obj) => {
  //       return obj.isMandatory === "Y" && isEmpty(obj.value);
  //     }
  //   );

  //   const canClose = filter(activeTask?.barriers, (barrier) => {
  //     return isEmpty(barrier.description);
  //   });

  //   isEmpty(canClose) && isEmpty(emptyMandatoryTasks)
  //     ? setIsModalVisible(false)
  //     : notification.error({
  //         message: "Error",
  //         description: !isEmpty(emptyMandatoryTasks) ? "Please fill all the mandatory fields." : "Please provide Description to all the Barriers as Description can not empty.",
  //       });
  // };

  const getScorePayload = (activeSubTask: any) => {
    let paramsPayload: any = {};
    if (careManagementDependentFieldsForScore[activeSubTask?.description]) {
      Object.keys(careManagementDependentFieldsForScore[activeSubTask?.description])?.forEach((item: any) => {
        const tempSubTasks = find(activeTask?.subtasks, { description: item });
        paramsPayload[careManagementDependentFieldsForScore[activeSubTask?.description][item]] = tempSubTasks?.value?.trim() === "" ? null : tempSubTasks?.value;
      });
    } else {
      const assesmentRequiredSubtasks = filter(activeTask?.subtasks, { isAssesmentReq: "Y" });
      if (assesmentRequiredSubtasks.length > 0) {
        const paramsArray: (string | number)[] = [];
        assesmentRequiredSubtasks.forEach((d) => {
          paramsArray.push(d.value);
        });
        paramsPayload = { param1: paramsArray };
      }
    }
    return paramsPayload;
  };

  const calculateScore = ({ taskId }: any) => {
    setTaskIdGoingToUpdate(taskId);
    const activeSubTask = find(activeTask?.subtasks, { id: taskId });
    let paramsPayload = getScorePayload(activeSubTask);

    if (Object.keys(paramsPayload)?.length > 0) {
      setIsUpdating(true);
      CareCoordinationService.calculateScore({
        patientId: patientId,
        programId: props.programId,
        patientProgramId: props.patientProgramId,
        interventionId: activeIntervention?.id,
        taskId: props.taskId,
        subTaskId: taskId,
        name: activeSubTask.name,
        ...paramsPayload,
      }).subscribe({
        next: (v) => {
          const res = v?.data?.data;

          forEach(res, (item) => {
            const _activeSubTask = find(activeTask?.subtasks, { id: item.subtaskId });
            _activeSubTask.value = item?.value;
          });
          setProgramsData(programsData);
          setIsUpdating(false);
        },
        error: (e) => {
          setIsUpdating(false);
        },
      });
    } else {
      setModalData({ open: true, type: PROGRAM_EXISTS, programName: "", description: `The assessment flag isn't setup correctly in template` });
    }
    const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
      USER_ACTION_DESCRIPTION_SCORE_CALCULATE,
      `${get(activeTask, "description")}$|${USER_ACTION_LOCATION_TASK_BUTTON}`,
      CASE_STATUS_REASON_CALCULATE_BUTTON
    );
    membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
      next: (v) => {
        console.log("updated status successfully");
      },
      error: (e) => {
        console.log("update status failed");
      },
    });
  };

  return (
    <>
      <div className="ui-program-intervention-task-sub-tasks">
        <div className="ui-program-intervention-task-sub-tasks__body custom-scroll-bar">
          {/* history header */}
          {activeTask.historyFlag === "Y" ? (
            <History
              dependantSubTasks={dependantSubTasks}
              setDependantSubTasks={setDependantSubTasks}
              programsData={programsData}
              rules={rules}
              setIsUserOnHistory={setIsUserOnHistory}
              activeTask={activeTask}
              taskDescription={props.taskDescription}
              activeCopyTask={activeCopyTask}
              disableUpdate={disableUpdate}
              isUserOnHistory={isUserOnHistory}
              subTaskLastUpdatedDate={subTaskLastUpdatedDate}
              setSpinner={props.setSpinner}
              taskId={props.taskId}
              canEdit={props?.canEdit}
              disableNewInstance={activeTask?.status === COMPLETE || activeTask?.status === NOT_APPLICABLE}
              prvBtn={prvBtn}
              setPrvBtn={setPrvBtn}
              nxtBtn={nxtBtn}
              setNxtBtn={setNxtBtn}
            />
          ) : null}

          {/* subTask Listing */}
          {isEmpty(activeTask?.subtasks) ? (
            <DataNotFound message={NO_DATA_FOUND} />
          ) : (
            map(
              filter(activeTask?.subtasks, (item) => {
                const dependantIds = map(dependantSubTasks, (obj) => {
                  return obj.id;
                });
                return !includes(dependantIds, item.id) || !isEmpty(find(dependantSubTasks, { display: true, id: item.id }));
              }),
              (task: { options: any }, index: any) => {
                const taskId = get(task, "id", ACTIVE);
                // const taskStatus = get(task, "status", ACTIVE);
                const taskDescription = trim(get(task, "description", "")) || "";
                const placeholderDesc = taskDescription.slice(0, taskDescription.endsWith(":") ? -1 : taskDescription.length);
                const taskOptions = isEmpty(get(task, "options", [])) ? [] : get(task, "options", [])?.replaceAll("'", "").split(",");
                const taskValue = isEmpty(get(task, "value", [])) ? "" : get(task, "value", []).toString().replaceAll("[", "").replaceAll("]", "");
                const taskType = get(task, "type", null);
                const referenceName = get(task, "name", null);
                const _taskValue = taskValue?.split(", ");
                const isDisabled = activeTask?.status === COMPLETE || activeTask?.status === NOT_APPLICABLE;
                const taskIsMandatory = get(task, "isMandatory", "N");
                const scoreInfo = get(scoreData, referenceName, []);
                const scoreValue = stringToNum(get(task, "value"));
                const scoreLabel = !isNil(scoreValue)
                  ? find(scoreInfo, (score: any) => (score.upper_bound ? scoreValue <= score.upper_bound && scoreValue >= score.lower_bound : scoreValue === score.lower_bound))?.label
                  : "";

                const taskValidations: any = getTaskvalidations(task);
                const reminders = get(task, "reminders", []);

                //dateValueToDisplay function is used to clear the value of a date input if it does not satisfy the validation
                const dateValueToDisplay = ({ validation, value, displayValue, initialCondition }: any) => {
                  /* validation represents date validation , value represents the data on which the date validation needs to be applied so on success it's displayValue is displayed, 
                  displayValue represents data which we need to show with formatting , initialCondition is the requirement that the value must fulfill,
                   in addition to the date validation, to be displayed*/
                  return initialCondition ? (validation ? (!validation(moment(value)) ? displayValue : undefined) : displayValue) : undefined;
                };

                return (
                  <CareManagementCanEdit edit={props.canEdit} hide={false}>
                    {/* <Spin spinning={isUpdating && taskIdGoingToUpdate === taskId} key={taskId + index} indicator={<HealthemSpinner />}> */}
                    <div className="ui-program-intervention-task-sub-tasks__body__task" key={taskId + index}>
                      <div className="ui-program-intervention-task-sub-tasks__body__task__header">
                        {/* Description of the task */}
                        <div className="ui-program-intervention-task-sub-tasks__body__task__header__description">
                          {/* <ReadMoreForWidth text={taskDescription} /> */}
                          <div
                            className={`${
                              !isEmpty(find(dependantSubTasks, { display: true, id: taskId })) ? "ui-program-intervention-task-sub-tasks__body__task__header__description__subTask-indentation" : ""
                            }`}
                          >
                            {taskDescription}
                            {taskIsMandatory === "Y" ? <span className="ui-program-intervention-task-sub-tasks__body__task__header__description__required">*</span> : null}
                          </div>
                          {taskType === ActionButton && (
                            <>
                              <Button
                                onClick={() => {
                                  calculateScore({ taskId: taskId });
                                }}
                                disabled={isUserOnHistory}
                              >
                                {task?.options}
                              </Button>
                              {!isEmpty(scoreInfo) && (
                                <span
                                  className="ui-program-intervention-task-sub-tasks__body__task__header__score-link"
                                  onClick={() => {
                                    setModalData({ open: true, type: SCORE_RANGES, scorePopupData: scoreInfo });
                                  }}
                                >
                                  View Range
                                </span>
                              )}
                            </>
                          )}
                        </div>
                        {taskType === Info &&
                          (size(_taskValue) > 1 ? (
                            <Collapse defaultActiveKey={["1"]} expandIconPosition="right">
                              <Panel header="" key="1">
                                {map(_taskValue, (value, index) => {
                                  return (
                                    <div key={value + index} className="ui-program-intervention-task-sub-tasks__body__task__header__value">
                                      {value}
                                    </div>
                                  );
                                })}
                              </Panel>
                            </Collapse>
                          ) : (
                            map(_taskValue, (value, key) => {
                              return (
                                <div key={value + key} className="ui-program-intervention-task-sub-tasks__body__task__header__value">
                                  {value}{" "}
                                </div>
                              );
                            })
                          ))}

                        {taskType !== ActionNoValue && (
                          <>
                            {/* Value of the task */}
                            {taskType === ActionFreeText && (
                              <InputField
                                className="ui-program-intervention-task-sub-tasks__body__task__header__value"
                                value={taskValue}
                                disabled={taskType === Info || isDisabled || isUserOnHistory}
                                onBlur={(value) => updateSubTaskGroup({ value: `${value}`, taskId: taskId })}
                                bordered={true}
                                // key={taskValue}
                                taskValidations={taskValidations}
                                placeholder={placeholderDesc}
                              />
                            )}
                            {/** Options */}
                            {taskType === ActionRadio && (
                              <CustomRadioGroup
                                isDisabled={isDisabled || isUserOnHistory}
                                taskValue={taskValue}
                                updateTask={updateSubTaskGroup}
                                taskOptions={taskOptions}
                                taskId={taskId}
                                serviceCallFlag={serviceCallFlag}
                              />
                            )}

                            {taskType === ActionRadioPrgm && (
                              <CustomRadioGroup
                                isDisabled={isDisabled || isUserOnHistory}
                                taskValue={taskValue}
                                updateTask={updateSubTaskGroup}
                                taskOptions={taskOptions}
                                taskId={taskId}
                                serviceCallFlag={serviceCallFlag}
                              />
                            )}

                            {taskType === ActionTextArea && (
                              <CustomTextArea
                                isDisabled={isDisabled || isUserOnHistory}
                                taskValue={taskValue}
                                updateTask={updateSubTaskGroup}
                                taskId={taskId}
                                className="ui-program-intervention-task-sub-tasks__body__task__header__text-area"
                                taskValidations={taskValidations}
                                placeholderDesc={placeholderDesc}
                              />
                            )}

                            {/** Single Date */}
                            {taskType === SingleDate && (
                              <DatePicker
                                disabled={isDisabled || isUserOnHistory}
                                format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
                                value={dateValueToDisplay({
                                  validation: taskValidations?.disabledDateFunc,
                                  value: taskValue,
                                  displayValue: moment(moment(taskValue).format(dateFormatConfig.get(getClientName())["defaultDateFormat"])),
                                  initialCondition: !(isEmpty(taskValue) || !moment(taskValue).isValid()),
                                })}
                                onChange={(date) => {
                                  // To show TCM -> admission and discharge dates in local format -> adding 'TCM Details' condition
                                  // Need to create new Date field which dont convert the date time to utc
                                  updateSubTaskGroup({
                                    value: date
                                      ? `${moment(date)
                                          .utc(activeTask.description === "TCM Details")
                                          .format()}`
                                      : "",
                                    taskId: taskId,
                                  });
                                }}
                                disabledDate={taskValidations?.disabledDateFunc}
                                className="ui-inpatient-management__header__range-picker"
                                dropdownClassName="reminder-picker"
                              />
                            )}
                            {/** Single Date */}
                            {taskType === ActionDateTime &&
                              !taskDescription?.toLowerCase()?.trim()?.includes("admission date") &&
                              !taskDescription?.toLowerCase()?.trim()?.includes("discharge date") && (
                                <DatePicker
                                  showTime
                                  disabled={isDisabled || isUserOnHistory}
                                  format={dateFormatConfig.get(getClientName())["dateTimeColumnFilterDisplayFormatWithTime"]}
                                  value={dateValueToDisplay({ validation: taskValidations?.disabledDateFunc, value: taskValue, displayValue: moment(taskValue), initialCondition: taskValue })}
                                  onChange={(date) => {
                                    updateSubTaskGroup({ value: date ? moment(date).utc().format() : "", taskId: taskId });
                                  }}
                                  disabledDate={taskValidations?.disabledDateFunc}
                                  className="ui-inpatient-management__header__range-picker"
                                  dropdownClassName="reminder-picker"
                                />
                              )}

                            {taskType === ActionDateTime &&
                              (taskDescription?.toLowerCase()?.trim()?.includes("admission date") || taskDescription?.toLowerCase()?.trim()?.includes("discharge date")) && (
                                <DatePicker
                                  showTime
                                  disabled={isDisabled || isUserOnHistory}
                                  format={dateFormatConfig.get(getClientName())["dateTimeColumnFilterDisplayFormatWithTime"]}
                                  value={dateValueToDisplay({ validation: taskValidations?.disabledDateFunc, value: taskValue, displayValue: moment(taskValue).utc(), initialCondition: taskValue })}
                                  onChange={(date) => {
                                    updateSubTaskGroup({ value: date ? moment(date).utc(true).format() : "", taskId: taskId });
                                  }}
                                  disabledDate={taskValidations?.disabledDateFunc}
                                  className="ui-inpatient-management__header__range-picker"
                                  dropdownClassName="reminder-picker"
                                />
                              )}

                            {/** Single DropDown */}
                            {taskType === SingleDropDown && (
                              <SingleSelect
                                value={isEmpty(taskValue) ? undefined : taskValue}
                                handleSelect={({ value, dropDownOptions }) => updateSubTaskGroup({ value: `${value}`, taskId: taskId, dropDownOptions })}
                                setIsUpdating={setIsUpdating}
                                referenceName={referenceName}
                                disabled={isDisabled || isUserOnHistory}
                                patientId={patientId}
                                interventionId={activeIntervention?.id}
                                subTaskId={taskId}
                              />
                            )}

                            {taskType === ActionMultiDropDown && (
                              <SingleSelect
                                value={isEmpty(taskValue) || taskValue?.trim() === "" ? undefined : taskValue}
                                handleSelect={({ value }) => updateSubTaskGroup({ value: `${value}`, taskId: taskId })}
                                setIsUpdating={setIsUpdating}
                                referenceName={referenceName}
                                disabled={isDisabled || isUserOnHistory}
                                patientId={patientId}
                                isMultiSelect={true}
                                interventionId={activeIntervention?.id}
                                subTaskId={taskId}
                              />
                            )}

                            {taskType === ActionMultiLevel && (
                              <MultiLevelSelect
                                value={isEmpty(taskValue) || taskValue?.trim() === "" ? undefined : taskValue}
                                handleSelect={({ value, dropDownOptions }) => updateSubTaskGroup({ value: `${value}`, taskId: taskId, dropDownOptions })}
                                setIsUpdating={setIsUpdating}
                                referenceName={referenceName}
                                disabled={isDisabled || isUserOnHistory}
                                patientId={patientId}
                                isMultiSelect={true}
                                interventionId={activeIntervention?.id}
                                subTaskId={taskId}
                              />
                            )}

                            {taskType === ActionRemainder && (
                              <Remainder
                                listOfReminders={reminders}
                                updateParentTask={(newReminder: any) => {
                                  if (newReminder) {
                                    props.taskReminderRef?.current?.addReminder(newReminder);
                                  }
                                  updateSubTaskGroup({newReminder : newReminder, taskId: taskId })
                                  props?.updateParentTaskNew &&
                                    props.updateParentTaskNew({
                                      status: INPROGRESS,
                                      taskId: props.taskId,
                                      newReminder: newReminder,
                                    });
                                }}
                                masterData={task}
                                screen={CARE_MANAGEMENT_SCREEN_TITLE}
                                patientId={patientId}
                                dependentSectionId={{ reminderType: "carecrdtn_subtask", subtaskId: taskId }}
                                readonly={isDisabled || !isTaskValid(activeTask)}
                                reminderOrigin={MEMBER_DETAILS_CARE_MANAGEMENT_TASKS}
                                disableRecurrence={true}
                                disabled={activeTask?.status === COMPLETE}
                                forceUpdateReminder={props?.forceUpdateReminder}
                              />
                            )}

                            {taskType === ActionButton && (
                              <>
                                <div style={{ marginRight: "10px" }}>{scoreValue}</div>
                                {!isEmpty(scoreInfo) && !isNil(scoreValue) && scoreLabel && (
                                  <div className="ui-program-intervention-task-sub-tasks__body__task__header__score-label">{capitalize(scoreLabel)}</div>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    {/* </Spin> */}
                  </CareManagementCanEdit>
                );
              }
            )
          )}
        </div>
        {/* </Modal> */}
        <div className="ui-program-intervention-task-sub-tasks__footer_wrapper">
          <div className="ui-program-intervention-task-sub-tasks__footer_wrapper--left">
            {haveMandatorySubTasks(activeTask) && (
              <div className="ui-program-intervention-task-sub-tasks__footer_wrapper--left__validation">
                <span>*</span>
                Please update the mandatory fields to continue
              </div>
            )}
          </div>
          <div className="ui-program-intervention-task-sub-tasks__footer_wrapper--right">
            {!isUserOnHistory ? (
              <div className="ui-program-intervention-task-sub-tasks__footer">
                <>
                  <Button
                    className="ui-program-intervention-task-sub-tasks__footer__cancel"
                    disabled={(getFilterChangedSubtask().length === 0 && activeTask.historyFlag === "N") || isUserOnHistory}
                    onClick={resetSubTaskFields}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="ui-program-intervention-task-sub-tasks__footer__update"
                    type="primary"
                    disabled={getFilterChangedSubtask().length === 0 || isUserOnHistory || !isTaskValid(activeTask, dependantSubTasks) || !isTaskValidationSuccess()}
                    onClick={updateSubTaskService}
                  >
                    Update
                  </Button>
                </>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <Program
        patientId={patientId}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        selectedValuesOfProgram={selectedValuesOfProgram}
        setSelectedValuesOfProgram={setSelectedValuesOfProgram}
        programEndDate={programEndDate}
        setProgramEndDate={setProgramEndDate}
        initialLoad={noop}
        loading={loading}
        setLoading={setLoading}
        programStartDate={undefined}
        setProgramLoading={noop}
        actionData={actionData.current}
      />
      <PopUpType data={modalData} onClose={() => setModalData({ open: false, type: "", programName: "", description: "", scorePopupData: [] })} />
    </>
  );
};

export const SingleSelect = (props: {
  patientId: any;
  setIsUpdating: (arg0: boolean) => void;
  referenceName: any;
  value: List<any> | null | undefined;
  handleSelect: (arg0: any) => void;
  disabled: boolean;
  isMultiSelect?: boolean;
  interventionId?: any;
  subTaskId?: any;
}) => {
  const [loadingOptions, setLoadingOptions] = useState<boolean>(false);
  const filterDropdowns = useDurableStore((state) => state.filterDropdowns);
  const setFilterDropdowns = useDurableStore((state) => state.setFilterDropdowns);

  const getOptions = () => {
    console.log("SingleSelect.getOptions");
    if (!Object.keys(filterDropdowns).includes(props.referenceName)) {
      const _dropdowns: any = { ...filterDropdowns };
      props.setIsUpdating(true);
      setLoadingOptions(true);
      memberDetailsService.fetchAttributeDropdown(props.referenceName, props.patientId, props.interventionId, props.subTaskId).subscribe({
        next: (response: any) => {
          _dropdowns[props.referenceName] = response.data.data.data;
          setFilterDropdowns(_dropdowns);
          props.setIsUpdating(false);
          setLoadingOptions(false);
        },
        error: (error) => {
          console.log(error);
          props.setIsUpdating(false);
          setLoadingOptions(false);
        },
      });
    }
  };

  return (
    <div
      onClick={() => {
        getOptions();
      }}
    >
      {props.isMultiSelect ? (
        <MultiSelect
          handleSelect={(value) => props.handleSelect({ value })}
          value={props.value}
          options={filterDropdowns[props.referenceName] || []}
          loadingOptions={loadingOptions}
          disabled={props.disabled}
        />
      ) : (
        <SimpleSelect
          handleSelect={(value) => props.handleSelect({ value, dropDownOptions: find(filterDropdowns[props.referenceName] || [], { value: value }) })}
          value={props.value}
          options={filterDropdowns[props.referenceName] || []}
          loadingOptions={loadingOptions}
          disabled={props.disabled}
        />
      )}
    </div>
  );
};

const CustomRadioGroup: FC<any> = ({ isDisabled, taskValue, updateTask, taskOptions, taskId, serviceCallFlag }) => {
  const [selectedSubTask, setSelectedSubTask] = useState(taskValue);

  useEffect(() => {
    console.log("CustomRadioGroup.useEffect");
    setSelectedSubTask(taskValue);
  }, [taskValue, serviceCallFlag]);

  const onSubTaskChange = (value: any) => {
    setSelectedSubTask(value);
  };
  return (
    <Radio.Group
      disabled={isDisabled}
      value={selectedSubTask}
      onChange={({ target: { value } }) => {
        onSubTaskChange(value);
        updateTask({ value: `${value}`, taskId: taskId });
      }}
      className="ui-program-intervention-task-sub-tasks__body__task__header__value__radio"
    >
      {map(taskOptions, (option, index) => {
        return (
          <Radio key={option + index} value={option}>
            {option}
          </Radio>
        );
      })}
    </Radio.Group>
  );
};

const CustomTextArea: FC<any> = ({
  className,
  isDisabled,
  taskValue,
  updateTask,
  taskId,
  taskValidations,
  placeholderDesc,
}: {
  className: string;
  isDisabled: boolean;
  taskValue: string;
  updateTask: (x: any) => void;
  taskId: number;
  taskValidations: any;
  placeholderDesc?: string;
}) => {
  const [value, setValue] = useState(taskValue);

  const { length, inputType } = taskValidations ?? {};

  const { maxLength, message: length_message } = length ?? {};

  const { inputTypeFunc, message: inputType_message } = inputType ?? {};

  useEffect(() => {
    setValue(taskValue);
  }, [taskValue]);

  const handleValue = (value: string) => {
    if (inputTypeFunc && value) {
      setValue(inputTypeFunc(value));
    } else {
      setValue(value);
    }
    updateTask({ value: `${value}`, taskId: taskId });
  };

  return (
    <TextArea
      className={`${className} ui-component-input custom-scroll-bar`}
      onChange={(e) => handleValue(e.target.value)}
      // onBlur={() => updateTask({ value: `${value}`, taskId: taskId })}
      disabled={isDisabled}
      value={value}
      rows={4}
      placeholder={`Enter the "${placeholderDesc}"`}
      autoSize={{ minRows: 4, maxRows: 8 }}
      maxLength={maxLength ?? undefined}
      showCount={maxLength ? true : false}
    />
  );
};

export default SubTask;
